import { AddressAccess } from 'contexts/account/types/account-company.type';
import { CreateOrderFormValues } from 'views/order-feed/features/my-supply-plan/types/create-order-form-values.type';
import { CreateOrderInput } from 'views/order-feed/features/my-supply-plan/types/create-order-input.type';
import { OrderListItem } from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/types/order-list-item.type';
import { DispatchSchedule, LegacyShippingSchedule } from 'views/order-feed/types/shipping-schedule.type';
import {
  formatDate,
  getOrderDateParts,
  getSiteTransportCompanies,
  getDefaultDispatchDate,
  shouldSendPlantAndVessel,
} from 'views/order-feed/features/my-supply-plan/utils/order-utils';

export const REPEAT_ORDER_ANCHOR_ID = 'repeat-order-anchor';

export const getDefaultCreateOrderDispatchDate = (
  dispatchSchedule: DispatchSchedule | undefined,
  orders: OrderListItem[] | undefined
): string => {
  const latestOrderDate = orders?.length
    ? orders.reduce((current, next) => (current.requestedDeliveryDate > next.requestedDeliveryDate ? current : next)).requestedDeliveryDate
    : undefined;

  return getDefaultDispatchDate(dispatchSchedule, latestOrderDate);
};

export const getDefaultTransportDetails = (
  addressAccess: AddressAccess[] | undefined,
  globalSiteId: string
): Pick<CreateOrderFormValues, 'transportMethod' | 'addressId'> => {
  const selectedTransportCompany = getSiteTransportCompanies(addressAccess, globalSiteId)?.[0];

  return {
    transportMethod: selectedTransportCompany?.key ?? '',
    addressId: selectedTransportCompany?.name ?? '',
  };
};

export const buildCreateOrderInput = (data: CreateOrderFormValues): CreateOrderInput => {
  const { plantId, vessel, requestedDispatchDate } = getOrderDateParts(data.requestedDispatchDate);
  const selectedPlantId = data.plantId || plantId;
  const selectedVessel = data.vessel || vessel;

  const request: CreateOrderInput = {
    transportMethod: data.transportMethod,
    requestedDispatchDate: formatDate(requestedDispatchDate),
    siteErpId: data.siteErpId,
    orderLines: data.orderLines.map((line) => ({
      itemNumber: line.itemNumber,
      orderQuantity: line.orderQuantity,
    })),
  };

  if (data.addressId) request.addressId = data.addressId;
  if (data.orderComment) request.orderComment = data.orderComment;
  if (data.customerOrderReference) request.customerOrderReference = data.customerOrderReference;

  // PlantId and Vessel are only required if the transport method is Vessel (13).
  if (shouldSendPlantAndVessel(data.transportMethod, selectedPlantId, selectedVessel)) {
    request.plantId = selectedPlantId;
    request.vessel = selectedVessel;
  }

  return request;
};
